<template>
  <div class="loading">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
};
</script>

<style scoped>
.loading {
  height: 100%;
  width: 100%;
  pointer-events: none;
  background-color: transparent;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner {
  border: 2px solid transparent;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1.2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
